import { render, staticRenderFns } from "./detailpage.vue?vue&type=template&id=470d32da&scoped=true&"
import script from "./detailpage.vue?vue&type=script&lang=js&"
export * from "./detailpage.vue?vue&type=script&lang=js&"
import style0 from "./detailpage.vue?vue&type=style&index=0&id=470d32da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d32da",
  null
  
)

export default component.exports